import React, {FunctionComponent, useEffect, useRef, useState } from 'react';

import { Button, ButtonProps} from '@cfa/react-components';
import {AsyncStatus} from 'enums';

export interface IButtonCountdownProps extends ButtonProps {
    countStart?: number
}

// ButtonCountdown is a button that enables after a countdown.
// This is useful for buttons that perform serious actions, to prevent users from accidentally clicking them.
export const ButtonCountdown: FunctionComponent<IButtonCountdownProps> = function (props) {
    const { children, countStart, disabled, ...rest } = props;

    const [count, setCount] = useState(props.countStart || 3);
    const [status, setStatus] = useState(AsyncStatus.Initial);
    const intervalIdRef = useRef<any>();

    function startCountdown() {
        setStatus(AsyncStatus.Loading);

        // We need to use a local variable because our reference to "count" will be stale when the interval runs.
        let i = count
        intervalIdRef.current = setInterval(() => {
            i--;
            if (i > 0) {
                setCount(i);
            } else {
                setStatus(AsyncStatus.Success);
                clearInterval(intervalIdRef.current);
            }
        }, 1000);
    }

    // Start the countdown when we're first enabled.
    useEffect(() => {
        if (!disabled && status === AsyncStatus.Initial) {
            startCountdown();
        }
    }, [disabled, status])

    // Cleanup
    useEffect(() => {
        return () => {
            clearInterval(intervalIdRef.current);
        }
    }, [])
    
    return (
        // Disable the button until the countdown has succeeded.
        <Button disabled={disabled || status !== AsyncStatus.Success} {...rest}>
            {children}
            {status === AsyncStatus.Loading && (<>
                &nbsp;({count})
            </>)}
        </Button>
    )
}